export default "__VITE_ASSET__DlWUv$Eg__"